<template>
  <!-- TABLE WRAPPER -->
<div class="w-100" id="table">
  <!-- HEADER -->
  <div class="row text-white fw-bold border-bottom py-2 bg-dark">
    <div class="col-4 ps-4">Indicator</div>
    <div class="col text-center">{{ selectedC }}<br>Rank Worldwide</div>
    <div class="col text-center">{{ selectedC }}<br>Score</div>
    <div class="col text-center">{{ region }}<br>Average Score</div>
    <div class="col text-center">World<br>Average Score</div>
  </div>

  <!-- MAIN CONTENT -->
  <div v-for="(lvl1item, lvl1index) in menuItems" :key="lvl1index">
    <input class="toggle" type="checkbox" :id="'toggle-' + lvl1item.id" />

    <!-- LEVEL 1 -->
    <div
      v-if="!['overallcountryrisk', 'opport'].includes(lvl1item.id.split('?')[0])"
      class="row align-items-stretch text-white border-bottom bg-level-1"
      style="min-height: 60px;"
    >
      <div class="col-4 d-flex align-items-center">
        <label :for="'toggle-' + lvl1item.id" class="w-100 cursor-pointer d-flex align-items-center">
          {{ lvl1item.label }}
          <span class="material-icons">arrow_drop_down</span>
        </label>
      </div>
      <div class="col text-center d-flex align-items-center justify-content-center">{{ lvl1item.rank }}</div>
      <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl1item.myvalue) }">{{ lvl1item.myvalue }}</div>
      <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl1item.Rvalue) }">{{ lvl1item.Rvalue }}</div>
      <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl1item.Wvalue) }">{{ lvl1item.Wvalue }}</div>
    </div>

    <!-- LEVEL 2 -->
    <div class="submenu" v-for="(lvl2item, lvl2index) in lvl1item.submenu || []" :key="lvl2index">
      <input class="toggle" type="checkbox" :id="'toggle-' + lvl2item.id" />
      <div class="row align-items-stretch text-white border-bottom bg-level-2" style="min-height: 60px;">
        <div class="col-4 d-flex align-items-center">
          <label :for="'toggle-' + lvl2item.id" class="cursor-pointer d-flex align-items-center">
            {{ lvl2item.label }} <span class="material-icons">arrow_drop_down</span>
          </label>
        </div>
        <div class="col text-center d-flex align-items-center justify-content-center">{{ lvl2item.rank }}</div>
        <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl2item.myvalue) }">{{ lvl2item.myvalue }}</div>
        <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl2item.Rvalue) }">{{ lvl2item.Rvalue }}</div>
        <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl2item.Wvalue) }">{{ lvl2item.Wvalue }}</div>
      </div>

      <!-- LEVEL 3 -->
      <div class="submenu" v-for="(lvl3item, lvl3index) in lvl2item.submenu || []" :key="lvl3index">
        <input class="toggle" type="checkbox" :id="'toggle-' + lvl3item.id" />
        <div class="row align-items-stretch text-white border-bottom bg-level-3" style="min-height: 60px;">
          <div class="col-4 d-flex align-items-center">
            <label :for="'toggle-' + lvl3item.id" class="cursor-pointer d-flex align-items-center">
              {{ lvl3item.label }}
              <span v-if="lvl3item.submenu?.length" class="material-icons">arrow_drop_down</span>
            </label>
          </div>
          <div class="col text-center d-flex align-items-center justify-content-center">{{ lvl3item.rank }}</div>
          <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl3item.myvalue) }">{{ lvl3item.myvalue }}</div>
          <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl3item.Rvalue) }">{{ lvl3item.Rvalue }}</div>
          <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl3item.Wvalue) }">{{ lvl3item.Wvalue }}</div>
        </div>

        <!-- LEVEL 4 -->
        <div class="submenu" v-for="(lvl4item, lvl4index) in lvl3item.submenu || []" :key="lvl4index">
          <input class="toggle" type="checkbox" :id="'toggle-' + lvl4item.id" />
          <div class="row align-items-stretch text-white border-bottom bg-level-4" style="min-height: 60px;">
            <div class="col-4 d-flex align-items-center">
              <label :for="'toggle-' + lvl4item.id" class="cursor-pointer d-flex align-items-center">
                {{ lvl4item.label }}
                <span v-if="lvl4item.submenu?.length" class="material-icons">arrow_drop_down</span>
              </label>
            </div>
            <div class="col text-center d-flex align-items-center justify-content-center">{{ lvl4item.rank }}</div>
            <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl4item.myvalue) }">{{ lvl4item.myvalue }}</div>
            <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl4item.Rvalue) }">{{ lvl4item.Rvalue }}</div>
            <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl4item.Wvalue) }">{{ lvl4item.Wvalue }}</div>
          </div>

          <!-- LEVEL 5 -->
          <div class="submenu" v-for="(lvl5item, lvl5index) in lvl4item.submenu || []" :key="lvl5index">
            <div class="row align-items-stretch text-white border-bottom bg-level-5" style="min-height: 60px;">
              <div class="col-4 d-flex align-items-center">
                <label>{{ lvl5item.label }}</label>
              </div>
              <div class="col text-center d-flex align-items-center justify-content-center">{{ lvl5item.rank }}</div>
              <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl5item.myvalue) }">{{ lvl5item.myvalue }}</div>
              <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl5item.Rvalue) }">{{ lvl5item.Rvalue }}</div>
              <div class="col text-center d-flex align-items-center justify-content-center" :style="{ backgroundColor: getColor(lvl5item.Wvalue) }">{{ lvl5item.Wvalue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
/* eslint-disable */
import api from '@/services/api'
import html2pdf from 'html2pdf.js';
import globalVar from "@/assets/globalVar.json"

export default {
  props: {
    selectedC: {
      type: String,
      required: true,
    },
    data_indicator: {
      type: Array,
      required: true,
    },
    data_indicator_world: {
      type: Array,
      required: true,
    },
    data_indicator_region: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    currentChartField: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      inputStrings: [],
      menuItems: [],
      RenameItem: {specificNames: {}},
      // csvPathFile: '',
      selectedC: '',
      country: {},
      region: '',
      regions_data: {},
      regionISO3: ''
    };
  },
  async mounted() {
    this.getRegions();
    await this.getCountries();
    this.getDataFromCsv();
    this.getDataIndicator();
    this.getDataIndicatorRegion();
    this.getDataIndicatorWorld();
    this.getSsindLab();
  },
  created() {
    // this.csvPathFile = 'app.json'
  },
  methods: {
    getColor(value) {
      let rangesData = [];
      if (this.currentChartField === "opportunity"){
        rangesData = globalVar.opport
      } else {
        rangesData = globalVar.risk
      }

      let category = '';
      if (value >= 5) {
        category = rangesData[4].color;
      } else {
        category = '#808080'
        for (let i = 0; i < rangesData.length; i++) {
          if(value >= rangesData[i].rangeMin - 0.005 && value <= rangesData[i].rangeMax - 0.005){
            category = rangesData[i].color;
            break;
          }
        }
      }

      return category;
    },
    exportToCSV() {
      console.log("dl CSV opport")
      const data = this.RenameItem;
      const keys = ['label', 'rank', 'myvalue', 'Rvalue', 'Wvalue'];
      const headers = ['Label', 'Rank', 'Value', 'RegionValue', 'WorldValue'];

      if (typeof data === 'object' && data !== null) {
        let csvData = '';
        csvData += headers.join(',') + '\n';

        const escapeCSVValue = (value) => {
          if (value === undefined || value === null || value === 0) {
            return '';
          }
          const strValue = String(value);
          if (/[",\n]/.test(strValue)) {
            return `"${strValue.replace(/"/g, '""')}"`;
          }
          return strValue;
        };

        const flattenObject = (obj) => {
          return keys.map(key => escapeCSVValue(obj[key])).join(',');
        };

        for (const key in data) {
          if (key !== 'specificNames' && data.hasOwnProperty(key)) {
            csvData += flattenObject(data[key]) + '\n';
          }
        }

        const specificNames = data['specificNames'];
        if (specificNames && typeof specificNames === 'object') {
          for (const key in specificNames) {
            if (specificNames.hasOwnProperty(key) && key !== 'undefined') {
              csvData += flattenObject(specificNames[key]) + '\n';
            }
          }
        }

        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'IndicatorTable_' + this.selectedC + '.csv';
        a.style.display = 'none';

        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        console.error('Data is not an object or is null.');
      }
    },
    exportToPDF() {
        const element = document.getElementById('table');
        html2pdf()
          .from(element)
          .save('IndicatorTable.pdf');
      },
      exportToJSON() {
      const jsonData = JSON.stringify(this.RenameItem);
      const blob = new Blob([jsonData], { type: 'application/json' });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'IndicatorData.json';
      a.style.display = 'none';

      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    },
    async getCountries() {
        try {
            const response = await api.get('/countries?cnttype=REG');
            const data = response.data;
            data.data.forEach(obj => {
              this.country[obj.country_name] = {
                region: obj.region_name
              }
            })
            const countryRegion = this.$route.params.element;
            for (const countryName in this.country) {
              if (countryName === countryRegion) {
                const countryData = this.country[countryName];
                this.region = countryData.region;
                break;
              }
            }
            for (const regionName in this.regions_data) {
              const region = this.regions_data[regionName];
              if (regionName == this.region)
                this.regionISO3 = region.region
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des pays :', error);
        }
    },
    async getRegions() {
      try {
        const response = await api.get('/regions');
        const data = response.data;
        data.data.forEach(obj => {
              this.regions_data[obj.name] = {
                region: obj.id
              }
          })
      } catch (error) {
        console.error('Erreur lors de la récupération des regions_data :', error);
      }
    },
    getDataIndicator() {
        this.selectedC = this.$route.params.element;
        this.data_indicator.forEach(indicator => {
          for (const key in this.RenameItem) {
            if (this.RenameItem.hasOwnProperty(key))
              if (key == indicator.symbol) {
                this.RenameItem[key].myvalue = Math.round(indicator.myvalue * 100) / 100;
                this.RenameItem[key].rank = indicator.rank;
              }
          }
          for (const key in this.RenameItem.specificNames) {
            if (this.RenameItem.specificNames.hasOwnProperty(key)) {
              const lastSlashIndex = key.lastIndexOf('/');
              if (lastSlashIndex !== -1) {
                const newKey = key.substring(lastSlashIndex + 1);
                if (newKey === indicator.symbol) {
                  this.RenameItem.specificNames[key].myvalue = Math.round(indicator.myvalue * 100) / 100;
                  this.RenameItem.specificNames[key].rank = indicator.rank;
                }
              }
            }
          }
        })
    },
    async getDataIndicatorRegion() {
        console.log("this.data_indicator_region DL",this.data_indicator_region)
        this.data_indicator_region.forEach(indicator => { 
            for (const key in this.RenameItem) {
                if (this.RenameItem.hasOwnProperty(key))
                    // console.log("key",key);
                    // console.log("indicator.symbol",indicator.symbol)
                  if (key == indicator.symbol) {
                    // console.log("Ok");
                    // console.log(Math.round(indicator.value * 100) / 100);
                    this.RenameItem[key].Rvalue = Math.round(indicator.value * 100) / 100;
                  }
            }
            for (const key in this.RenameItem.specificNames) {
              if (this.RenameItem.specificNames.hasOwnProperty(key)) {
                const lastSlashIndex = key.lastIndexOf('/');
                if (lastSlashIndex !== -1) {
                  const newKey = key.substring(lastSlashIndex + 1);
                  if (newKey === indicator.symbol) {
                    this.RenameItem.specificNames[key].Rvalue = Math.round(indicator.value * 100) / 100;
                  }
                }
              }
            }
          })

          console.log("this.RenameItem",this.RenameItem)
    },
    getDataIndicatorWorld() {
      this.data_indicator_world.forEach(indicator => {
            for (const key in this.RenameItem) {
                if (this.RenameItem.hasOwnProperty(key))
                  if (key == indicator.symbol) {
                    this.RenameItem[key].Wvalue = Math.round(indicator.value * 100) / 100;
                  }
            }
            for (const key in this.RenameItem.specificNames) {
              if (this.RenameItem.specificNames.hasOwnProperty(key)) {
                const lastSlashIndex = key.lastIndexOf('/');
                if (lastSlashIndex !== -1) {
                  const newKey = key.substring(lastSlashIndex + 1);
                  if (newKey === indicator.symbol) {
                    this.RenameItem.specificNames[key].Wvalue = Math.round(indicator.value * 100) / 100;
                  }
                }
              }
            }
          })
    },
    buildRenameItem(obj, path) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key];
          const newPath = path ? `${path}/${key}` : key;
          if (item && item.code && item.code.indexOf('/') === -1) {
            this.RenameItem[item.code] = { label: item.description, rank : item.rank, Rvalue : item.Rvalue };
          } else {
            this.RenameItem.specificNames[item.code] = { label: item.description, rank : item.rank, Rvalue : item.Rvalue };
          }
          if (typeof item === 'object' && !Array.isArray(item)) {
            this.buildRenameItem(item, newPath);
          }
        }
      }
    },
    getDataFromCsv() {
      for (const key in this.data) {
        if (this.data.hasOwnProperty(key)) {
          const item = this.data[key];
          this.inputStrings.push(item.code);
        }
      }
      this.buildRenameItem(this.data, '');
    },
    async getSsindLab() {
      try {
          const response = await api.get('/ssind');
          const data = response.data;
          this.inputStrings.forEach(inputString => {
              this.generateMenu(inputString);
          });

          this.RenameInput(this.menuItems);
          console.log("this.menuItems",this.menuItems)

      } catch (error) {
          console.error('Erreur lors de la récupération des Indicateurs :', error);
      }
    },
    generateMenu(inputString) {
      const levels = inputString.split('/');
      let currentLevel = this.menuItems;

      levels.forEach((level) => {
        let existingItem = currentLevel.find(item => item.label === level);

        if (!existingItem) {
          const menuItem = {
            id: `${level}?${Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)}`,
            label: level,
            submenu: [],
            value: null,
            rank: 0,
            region: 0,
            world: 0,
          };
          currentLevel.push(menuItem);
          currentLevel = menuItem.submenu;
        } else {
          currentLevel = existingItem.submenu;
        }
      });
    },
    RenameInput(tab) {
      this.recursiveRename(tab);
  },
  recursiveRename(submenu, parentLabel = null) {
    submenu.forEach((item) => {
      const itemLabel = item.label;
      const combinedLabel = parentLabel ? parentLabel + "/" + itemLabel : itemLabel;

      if (this.RenameItem.specificNames[combinedLabel] && this.RenameItem.specificNames[combinedLabel].label) {
        item.label = this.RenameItem.specificNames[combinedLabel].label;
        item.myvalue = this.RenameItem.specificNames[combinedLabel].myvalue;
        item.rank = this.RenameItem.specificNames[combinedLabel].rank;
        item.Rvalue = this.RenameItem.specificNames[combinedLabel].Rvalue;
        item.Wvalue = this.RenameItem.specificNames[combinedLabel].Wvalue;
        if (item.myvalue == 0) {
          item.myvalue = null
        }
        if (item.Rvalue == 0) {
          item.Rvalue = null
        }
        if (item.Wvalue == 0) {
          item.Wvalue = null
        }
      } else if (parentLabel && this.RenameItem.specificNames[parentLabel] && this.RenameItem.specificNames[parentLabel].label) {
        item.label = this.RenameItem.specificNames[parentLabel].label;
        item.myvalue = this.RenameItem.specificNames[parentLabel].myvalue;
        item.rank = this.RenameItem.specificNames[parentLabel].rank;
        item.Rvalue = this.RenameItem.specificNames[parentLabel].Rvalue;
        item.Wvalue = this.RenameItem.specificNames[parentLabel].Wvalue;
        if (item.Rvalue == 0) {
          item.Rvalue = null
        }
        if (item.myvalue == 0) {
          item.myvalue = null
        }
        if (item.Wvalue == 0) {
          item.Wvalue = null
        }
      } else if (this.RenameItem[itemLabel] && this.RenameItem[itemLabel].label) {
        item.label = this.RenameItem[itemLabel].label;
        item.myvalue = this.RenameItem[itemLabel].myvalue;
        item.rank = this.RenameItem[itemLabel].rank;
        item.Rvalue = this.RenameItem[itemLabel].Rvalue;
        item.Wvalue = this.RenameItem[itemLabel].Wvalue;
        if (item.myvalue == 0) {
          item.myvalue = null
        }
        if (item.Rvalue == 0) {
          item.Rvalue = null
        }
        if (item.Wvalue == 0) {
          item.Wvalue = null
        }
      }

      if (item.submenu && item.submenu.length > 0) {
        this.recursiveRename(item.submenu, combinedLabel);
      }
    });
  },
  },
};
</script>

  
